import React, { PropTypes } from 'react';
import BucketHeader from 'common/BucketHeader';
import LinkWithFlags from 'common/LinkWithFlags';
import injectIntl, { intlShape } from 'common/injectIntl';

const BucketHeaderContainer = ({
    className,
    displaySize,
    intl: { formatMessage },
    name,
    logo,
    link,
    messages,
    size
}) => {
    const title = `${name}${(displaySize && size) ? ` (${size})` : ''}`;
    return (
        <header className={className}>
            {link ? (
                <LinkWithFlags to={link} className="collection_title_link" data-route="false">
                    <BucketHeader title={title} logo={logo} seeAllText={formatMessage(messages['page.bucket.header.seeAll'])} />
                </LinkWithFlags>
            ) : (
                <span>
                    <BucketHeader title={title} logo={logo} seeAllText="" />
                </span>
            )}
        </header>
    );
};

BucketHeaderContainer.propTypes = {
    className: PropTypes.string,
    displaySize: PropTypes.bool,
    name: PropTypes.string,
    logo: PropTypes.object,
    size: PropTypes.number,
    link: PropTypes.string,
    intl: intlShape.isRequired,
    messages: PropTypes.object.isRequired
};

export default injectIntl(BucketHeaderContainer);



// WEBPACK FOOTER //
// ./app/webapp/page/buckets/BucketHeaderContainer.js